import './styles.css';
import React from 'react';
import Avatar from '../../../../../../images/face-0.jpg';
import moment from 'moment';
import { Modal } from 'react-bootstrap';

const ModalPerson = ({ api, personData, modalState, onModalHide }) => {
    const noInfoMessage = 'Sin información';

    return (
        <Modal
            className="person-about"
            show={modalState}
            onHide={() => onModalHide(false)}
        >
            <Modal.Header closeButton>
                <Modal.Title>Detalles sobre {personData.name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <div className="init-data">
                        <div>
                            <img className="user-profile-photo" src={personData.photo ? api.appFiles.getUrl(personData.photo.id) : Avatar} alt="Fotografía del usuario" />
                            <h4>{personData.name} {personData.patLastName ? personData.patLastName : ''} {personData.matLastName ? personData.matLastName : ''}</h4>
                        </div>
                    </div>
                    <h6>Información Personal.</h6>
                    <table>
                        <tbody>
                            <tr>
                                <td>Fecha de Nacimiento:</td>
                                <td>{personData.birthDate ? moment.utc(personData.birthDate).format('D-MM-YYYY') : noInfoMessage}</td>
                            </tr>
                            <tr>
                                <td>Email:</td>
                                <td>
                                    <a href={`mailto:${personData.email}`}>{personData.email ? personData.email : noInfoMessage}</a>
                                </td>
                            </tr>
                            <tr>
                                <td>Teléfono Fijo:</td>
                                <td>
                                    <a href={`tel:${personData.fixedPhone}`}>{personData.fixedPhone ? personData.fixedPhone : noInfoMessage}</a>
                                </td>
                            </tr>
                            <tr>
                                <td>Teléfono Móvil:</td>
                                <td>
                                    <a href={`tel:${personData.mobilePhone}`}>{personData.mobilePhone ? personData.mobilePhone : noInfoMessage}</a>
                                </td>
                            </tr>
                            <tr>
                                <td>Residencia:</td>
                                <td>
                                    {personData.city}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <h6>Detalles profesionales.</h6>
                    <table>
                        <tbody>
                            <tr>
                                <td>Título:</td>
                                <td>{personData.title ? personData.title : noInfoMessage}</td>
                            </tr>
                            <tr>
                                <td>RFC:</td>
                                <td>{personData.rfc ? personData.rfc : noInfoMessage}</td>
                            </tr>
                            <tr>
                                <td>Especialidad:</td>
                                <td>{personData.specialty && personData.specialty.name ? personData.specialty.name : noInfoMessage}</td>
                            </tr>
                            <tr>
                                <td>Cédula Profesional:</td>
                                <td>{personData.professionalLicense ? personData.professionalLicense : noInfoMessage}</td>
                            </tr>
                            <tr>
                                <td>Número de certificación:</td>
                                <td>{personData.certificationNumber ? personData.certificationNumber : noInfoMessage}</td>
                            </tr>
                            <tr>
                                <td>Información académica:</td>
                                <td>
                                    {
                                        personData.academicResume
                                            ? <a href={api.appFiles.getDownloadUrl(personData.academicResume.id)}>{personData.academicResume.originalName}</a>
                                            : noInfoMessage
                                    }
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <h6>Información pública de contacto</h6>
                    <pre>{personData.contactData}</pre>
                </div>
            </Modal.Body>
        </Modal>
    );
};
export default ModalPerson;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/PublicInGral/components/ModalPerson/ModalPerson.js